import Link from "next/link";

import Modal from "components/shared/modal";
import ButtonLink from "components/shared/buttonLink";
import { LOCAL_STORAGE_KEY } from "@/constants/owner/management/localStorageKey";

type Props = {
  showShareModal: boolean;
  setShowShareModal: React.Dispatch<React.SetStateAction<boolean>>;
};

//仕事共有モーダル
const TaskShareUrlCopyModal_caseOff: React.FC<Props> = ({
  showShareModal,
  setShowShareModal
}) => {
  return (
    <Modal
      show={showShareModal}
      showClose={true}
      setShow={setShowShareModal}
      title="作業報告をURLで共有"
    >
      <div className="px-32 pb-16 pt-8 text-[1.4rem] leading-normal">
        <p>
          作業報告の共有URLをコピーしてメールなどに貼り付けて共有できます。
          <br />
          設定をONにして、共有範囲と共有する仕事を選択してください。
        </p>
        <div
          className="mb-8 mt-8"
          onClick={() =>
            sessionStorage.setItem(LOCAL_STORAGE_KEY.SAVE_TAB_VALUE_KEY, "0")
          }
        >
          <Link href="/owner/management" passHref>
            <ButtonLink width="100%" btnColor="pink">
              設定をONにする
            </ButtonLink>
          </Link>
        </div>
      </div>
    </Modal>
  );
};

export default TaskShareUrlCopyModal_caseOff;
